/**
 * @desc 查询门店区域信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** parent_code */
  parent_code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<Array<defs.store.StoreAreaVO>>>(
    `/storeapi/api/v4/store/areas`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.StoreAreaVO>>;
export default req;
